/* eslint-disable react/prop-types */
import React from "react";
import { Link as RouterLink, useLocation, useNavigate } from "react-router-dom";

import { IconButton, Link } from "@mui/material";

import Button from "components/common/Button";

import ArrowBackOutlinedIcon from "@mui/icons-material/ArrowBackOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import "./top-header.scss";

function TopHeader({
  breadcrumbs,
  primaryTitle = "Home",
  backIcon = "",
  primaryBtn,
  secondaryBtn,
  title,
  secondaryBtnVariant = "outlined",
  secondaryBtnIcon = <EditOutlinedIcon className="button-secondary-icon" />,
  subtext,
  linkName = "",
  link = "#",
  primaryLink = "/main/dashboard",
  primaryBtnClick,
  secondaryBtnClick,
  showBottomBorder = true,
}) {
  const location = useLocation();
  const navigate = useNavigate();

  const headerClass = `top-header-wrapper ${secondaryBtn || primaryBtn ? "py-05" : "py-1"} ${showBottomBorder ? "" : "no-bottom-border"}`;

  return (
    <div className={headerClass}>
      <div className="header-content-left">
        {breadcrumbs && (
          <div className="flex items-center">
            <Link className="header-link" component={RouterLink} to={primaryLink}>
              <p className="header-link para-body-xs-regular">{primaryTitle}</p>
            </Link>
            <div className="header-divider-wrapper">
              <p className="header-link-divider px-05">/</p>
            </div>
            <Link
              component={RouterLink}
              to={link}
              className="header-link-secondary"
              aria-current={link === location.pathname ? "page" : undefined}
            >
              <p className="header-link-secondary para-body-xs-regular">{linkName}</p>
            </Link>
          </div>
        )}
        <div className="flex items-center gap-05 cursor-pointer">
          {backIcon && (
            <IconButton size="small" onClick={() => navigate(backIcon)}>
              <ArrowBackOutlinedIcon className="black-icon" />
            </IconButton>
          )}
          <div>
            <p className="heading-h3-semibold">{title}</p>
            {subtext && <p className="titlebar-subtext">{subtext}</p>}
          </div>
        </div>
      </div>

      {(secondaryBtn || primaryBtn) && (
        <div className="flex items-center gap-075">
          {secondaryBtn && (
            <Button
              variant={secondaryBtnVariant}
              label={secondaryBtn}
              onClick={secondaryBtnClick}
              size="large"
              startIcon={secondaryBtnIcon}
            />
          )}
          {primaryBtn && (
            <Button
              variant="contained"
              label={primaryBtn}
              onClick={primaryBtnClick}
              size="large"
              startIcon={<EditOutlinedIcon className="button-primary-icon" />}
            />
          )}
        </div>
      )}
    </div>
  );
}

export default TopHeader;
